import { quickOrderProductListStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

quickOrderProductListStyles.quantityOrdered = {
    labelPosition: "top",
    labelProps: {
        css: css`
            width: auto;
            display: inline-flex;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: 50%;
            margin: auto;
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
            input[type="number"] {
                -moz-appearance: textfield;
                margin: auto;
            }
        `,
    },
};

quickOrderProductListStyles.quantityGridItem = {
    width: [6, 6, 3, 3, 4],
    css: css`
        > div[class^="FormFieldStyle"] {
            justify-content: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            justify-content: flex-start;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
            > div:first-child {
                display: none;
            }
        }
    `,
};

quickOrderProductListStyles.removeProductGridItem = {
    css: css`
        text-align: center;
        display: block;
        button[class^="ButtonWrapper"] {
            display: none;
        }
    `,
    width: [2, 2, 2, 1, 1],
};

quickOrderProductListStyles.productInfoGridItem = { width: [8, 8, 8, 9, 9] };

quickOrderProductListStyles.brandAndProductDescriptionGridItem = {
    width: [12, 12, 12, 5, 4],
    css: css`
        flex-direction: column;
    `,
};

quickOrderProductListStyles.priceAndQuantityGridItem = {
    width: [12, 12, 12, 7, 8],
};

quickOrderProductListStyles.extendedPriceGridItem = {
    width: [6, 6, 5, 5, 4],
    css: css`
        justify-content: center;
        span {
            color: ${getColor("primary")};
            font-size: 20px;
            align-self: flex-start;
        }
    `,
};

quickOrderProductListStyles.removeProductClickable = {
    css: css`
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 15px;
        margin-top: 12px;
    `,
};

quickOrderProductListStyles.priceGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        flex-direction: column;
        justify-content: center;
        > section {
            padding-top: 0;
        }
        span[data-test-selector="productPrice_unitNetPrice"] {
            color: #333;
            font-size: 16px;
        }
        span[data-test-selector="productPrice_unitOfMeasureLabel"] {
            font-size: 16px;
        }
    `,
};
